import * as React from 'react';
/**
 * @ignore - internal component.
 */
const ButtonGroupContext = /*#__PURE__*/React.createContext({});
if (process.env.NODE_ENV !== 'production') {
  ButtonGroupContext.displayName = 'ButtonGroupContext';
}
export default ButtonGroupContext;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/ButtonGroup/ButtonGroupContext.js
// module id = 432
// module chunks = 22